const DarkThemeColors = [
  {
    name: 'GREEN_THEME',
    palette: {
      primary: {
        main: '#6DC860',
        light: '#214A1D',
        dark: '#9FE095',
        contrastText: '#0D280B',
      },
      secondary: {
        main: '#9FE095',
        light: '#1B3C1A',
        dark: '#C9EEC4',
        contrastText: '#0D280B',
      },
      background: {
        default: '#0D1A0C',
        dark: '#0D1A0C',
        paper: '#111E10',
      },
    },
  },
  {
    name: 'BLUE_THEME',
    palette: {
      primary: {
        main: '#42A5F5',
        light: '#1A2C40',
        dark: '#64B5F6',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#49BEFF',
        light: '#1C455D',
        dark: '#23AFDB',
        contrastText: '#ffffff',
      },
      background: {
        default: '#0D1929',
        dark: '#0D1929',
        paper: '#112240',
      },
    },
  },
  {
    name: 'AQUA_THEME',
    palette: {
      primary: {
        main: '#0074BA',
        light: '#103247',
        dark: '#006DAF',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#47D7BC',
        light: '#0C4339',
        dark: '#39C7AD',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'PURPLE_THEME',
    palette: {
      primary: {
        main: '#763EBD',
        light: '#26153C',
        dark: '#6E35B7',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#95CFD5',
        light: '#09454B',
        dark: '#8BC8CE',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'CYAN_THEME',
    palette: {
      primary: {
        main: '#01C0C8',
        light: '#003638',
        dark: '#00B9C0',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#FB9678',
        light: '#40241C',
        dark: '#F48B6C',
        contrastText: '#ffffff',
      },
    },
  },
  {
    name: 'ORANGE_THEME',
    palette: {
      primary: {
        main: '#FF7043',
        light: '#402E32',
        dark: '#FF8A65',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#0074BA',
        light: '#082E45',
        dark: '#006FB1',
        contrastText: '#ffffff',
      },
    },
  },
];

export { DarkThemeColors };